var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConversion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 1.33333H1.5L1.5 6.66667H7.5V1.33333ZM1.5 0C0.671573 0 0 0.596954 0 1.33333V6.66667C0 7.40305 0.671573 8 1.5 8H7.5C8.32843 8 9 7.40305 9 6.66667V1.33333C9 0.596954 8.32843 0 7.5 0H1.5ZM16.5 9.33333H10.5V14.6667H16.5V9.33333ZM10.5 8C9.67157 8 9 8.59695 9 9.33333V12.6667C6.61376 12.6667 4.61213 11.2598 3.96723 9.33333H2.41745C3.1 12.0058 5.79607 14 9 14V14.6667C9 15.403 9.67157 16 10.5 16H16.5C17.3284 16 18 15.403 18 14.6667V9.33333C18 8.59695 17.3284 8 16.5 8H10.5ZM9.00002 3.33333V2C12.204 2 14.9 3.99422 15.5826 6.66667H14.0328C13.3879 4.74014 11.3863 3.33333 9.00002 3.33333Z",
    fill: "#585C6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversion);
export default __webpack_public_path__ + "static/media/conversion.51bcf080.svg";
export { ForwardRef as ReactComponent };